import React, { Component } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import DefaultLayout from "layouts/Default";
import { SpaceEvent } from "services/entities/events";
import { loadSpaceEvents } from "services/events";
import { handleError } from "util/errors";
import { Space } from "services/entities/spaces";
import { Button } from "@material-ui/core";
import { DateTime } from "util/time";
import { NextIcon, PreviousIcon } from "components/Icon";
import ProgressSpinner from "components/ProgressSpinner";
import Modal from "components/Modal";
import EventCard from "components/events/EventCard";
import NoEventsImage from "assets/img/events/no-events.png";
import "./index.scss";
import SpaceSelector from "components/SpaceSelector";
import NextRouteURLs from "NextRouteURLs";

interface ListEventsPageState {
  events: SpaceEvent[] | null;
  selectedSpaceCode: string | null;
  selectedMonth: DateTime;
  openEvent: SpaceEvent | null;
  eventModalOpen: boolean;
}

class ListEventsPage extends Component<
  RouteComponentProps,
  ListEventsPageState
> {
  state: ListEventsPageState = {
    events: null,
    selectedSpaceCode: null,
    selectedMonth: DateTime.today(),
    openEvent: null,
    eventModalOpen: false,
  };

  get selectedSpace(): string | null {
    return this.state.selectedSpaceCode;
  }

  onSpacesLoaded = (spaces: Space[]) => {
    this.setState({
      selectedSpaceCode: spaces.length > 0 ? spaces[0].code : null,
    });
    this.loadEvents();
  };

  onSpaceChanged = (code: string) => {
    this.setState({ selectedSpaceCode: code });
    this.loadEvents();
  };

  loadEvents() {
    this.setState({ events: null }, () => {
      const selectedMonth = this.state.selectedMonth;
      const selectedSpace = this.selectedSpace!;
      loadSpaceEvents(10, {
        minTime: selectedMonth.startOf("month"),
        maxTime: selectedMonth.endOf("month"),
        space: selectedSpace,
      }).then(
        (events) => this.setState({ events: events }),
        (ex) => handleError("Failed loading events", ex)
      );
    });
  }

  onEventModalClosed = () => {
    this.setState({ eventModalOpen: false });
  };

  onNextMonthClick = () => {
    const selectedMonth = this.state.selectedMonth;
    this.setState({ selectedMonth: selectedMonth.addUnits(1, "months") });
    this.loadEvents();
  };

  onPreviousMonthClick = () => {
    const selectedMonth = this.state.selectedMonth;
    this.setState({ selectedMonth: selectedMonth.subtractUnits(1, "months") });
    this.loadEvents();
  };

  onBookClick = () => {
    const selectedSpace = this.selectedSpace;
    if (selectedSpace) {
      // change to book space URL when booking is public again
      window.location.href = NextRouteURLs.CONTACT
    }
  };

  onViewEventClick = (event: SpaceEvent) => {
    this.setState({ openEvent: event, eventModalOpen: true });
  };

  renderEventCard = (event: SpaceEvent, index: number) => {
    return (
      <EventCard
        event={event}
        key={index}
        onClick={() => this.onViewEventClick(event)}
        linkVisible={false}
        descriptionVisible={false}
      >
        <Button className="more">More details</Button>
      </EventCard>
    );
  };

  render() {
    const { events, selectedMonth, openEvent, eventModalOpen } = this.state;
    const previousDisabled = selectedMonth.lessThanOrEqual(
      DateTime.now(),
      "month"
    );
    return (
      <DefaultLayout id="list-events-page">
        <section className="banner">
          <h1>Upcoming Events</h1>
          <p>See what is coming up at your local Sook space.</p>
          <SpaceSelector
            label="Location"
            onChange={this.onSpaceChanged}
            onSpacesLoaded={this.onSpacesLoaded}
            value={this.state.selectedSpaceCode}
          />
          <hr />
        </section>
        <section className="dates">
          <button
            className="previous"
            disabled={previousDisabled}
            onClick={this.onPreviousMonthClick}
          >
            <PreviousIcon />
          </button>
          <span className="current">{selectedMonth.format("MMMM YYYY")}</span>
          <button className="next" onClick={this.onNextMonthClick}>
            <NextIcon />
          </button>
        </section>
        {events === null && (
          <section className="events loading">
            <ProgressSpinner />
          </section>
        )}
        {events && events.length === 0 && (
          <section className="events empty">
            <img src={NoEventsImage} alt="" />
            <p>No upcoming events at this location</p>
            <Button onClick={this.onBookClick}>Book now</Button>
          </section>
        )}
        {events && events.length > 0 && (
          <section className="events">
            {events!.map(this.renderEventCard)}
          </section>
        )}
        <Modal
          open={eventModalOpen}
          closable={true}
          onClosing={this.onEventModalClosed}
          className="event-modal"
        >
          {openEvent && <EventCard event={openEvent} cssClass="large" />}
        </Modal>
      </DefaultLayout>
    );
  }
}

export default withRouter(ListEventsPage);
